import {createApp} from 'vue';
import i18n from "@/plugins/i18n";
import '@/plugins/RecaptchaStore';
import {
    ContactFormElement,
    MagazineFormElement,
    CustomerImagesElement,
    WoodSampleFormElement,
    CustomerReviewsElement,
    ConfiguratorEntryListElement,
    ProductListElement,
    MeasurementOrderFormElement,
    AiDesignFormElement,
} from '@webstacz/shop-components';
import styleSelect from "styleselect/js/styleselect";
import '@/plugins/Sentry';
import {isDesktop} from "@/plugins/Helpers";
import * as pako from 'pako';

const token: HTMLMetaElement | null = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.csrfToken = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const cmsElements: { [key: string]: any } = {
    ContactFormElement: ContactFormElement,
    AiDesignFormElement: AiDesignFormElement,
    MagazineFormElement: MagazineFormElement,
    CustomerReviewsElement: CustomerReviewsElement,
    CustomerImagesElement: CustomerImagesElement,
    WoodSampleFormElement: WoodSampleFormElement,
    ProductListElement: ProductListElement,
    ConfiguratorEntryListElement: ConfiguratorEntryListElement,
    MeasurementOrderFormElement: MeasurementOrderFormElement,
};

const syncStyleSelect = (select: HTMLSelectElement): void => {
    const styledSelect = document.querySelector(`.style-select[data-ss-uuid="${select.dataset.ssUuid}"]`);
    const selectedOption = styledSelect?.querySelector<HTMLElement>('.ss-selected-option');

    if (!styledSelect || !selectedOption) {
        return;
    }

    selectedOption.textContent = select.options[select.selectedIndex]?.textContent ?? '';
    selectedOption.dataset.value = select.value;

    for (const option of styledSelect.querySelectorAll<HTMLElement>('.ss-option')) {
        option.classList.toggle('ticked', option.dataset.value === select.value);
    }
};

window.onload = () => {
    let elements = document.querySelectorAll("[class*=cms-element-]");
    if (elements.length > 0) {
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i] as HTMLElement;
            if (element.dataset?.component && cmsElements[element.dataset?.component]) {
                const component = cmsElements[element.dataset?.component];
                let data: any = {};
                if (element.dataset?.props) {
                    const decodedData = atob(element.dataset?.props);
                    const uint8Array = new Uint8Array(decodedData.length);
                    for (let i = 0; i < decodedData.length; i++) {
                        uint8Array[i] = decodedData.charCodeAt(i);
                    }
                    const inflatedData = pako.inflate(uint8Array, {to: 'string'});
                    data = JSON.parse(inflatedData);
                }

                const app = createApp(component, {
                    elementId: element.dataset?.elementId ?? '',
                    ...data,
                    csrfToken: window.csrfToken,
                    params: {
                        ...data,
                        isDesktop: isDesktop,
                    },
                });

                app.use(i18n);
                app.mount(element);
            }
        }
    }

    /* @ts-ignore */
    for (const select of document.querySelectorAll<HTMLSelectElement>('.form-select')) {
        styleSelect(select);
        select.addEventListener('change', () => syncStyleSelect(select));
    }
};
